<template>
    <div class="wrap opti_wrap" :class="{pd110: btnFixed}" id="app">
        <div class="loading-wrap" :style="togg()">
            <div class="loading-box"><img src="https://resource.0168.net.cn/activity-mall/images/loading-img.gif" style="width: 120px; border-radius: 10px;padding-left: 0px;">
                <div style="width: 100%; color: white; padding: 10px 6px;">稍等片刻~</div>
            </div>
        </div>

        <div class="flow_top">
            <img src="https://resource.0168.net.cn/activity-mall/h5/theme0222/top.jpg" alt="" class="main-top">
        </div>

        <div class="flow_top flow_input_bg">
            <img :src="mode == 1 || mode == 2 ? inputBgImgSrc1_2 : inputBgImgSrc" alt="" class="main-top">
           
            <div class="formElement1" :class="{flow_select3 : mode == 3, flow_select : mode == 0, flow_select1 : mode == 1 || mode == 2}" >
                <i class="hand-step1" v-if="step == 1"></i>
                <div class="formBox van-cell-group van-hairline--top-bottom" v-if="mode == 0 || mode ==3">
                    <div class="form phone van-cell van-cell--required van-field">
                        <div class="van-cell__value van-cell__value--alone van-field__value">
                            <div class="van-field__body"><input type="tel" v-model="phonenum" id="inputPhone" placeholder="请输入你的手机号" class="van-field__control"></div>
                        </div>
                    </div>
                </div>

                <i class="hand-step2" v-if="step == 2"></i>
                <div class="formBox formBoxPhone van-cell-group van-hairline--top-bottom" v-if="mode == 3">
                    <div class="form phone van-cell van-cell--required van-field">
                        <div class="van-cell__value van-cell__value--alone van-field__value">
                            <div class="van-field__body">
                                <input type="number" inputmode="decimal" v-model="captcha" placeholder="请输入验证码" class="van-field__control">
                                <div class="van-field__button" v-if="timesCount === 0" @click="bindOpen">
                                    <div size="small" type="primary" style="color: rgb(240, 169, 25); font-size: 0.28rem; height: 1.1rem; line-height: 1.1rem;">
                                        <span style="margin-right: 0.2rem; position: relative; top: -0.02rem;">|</span>获取验证码
                                    </div>
                                </div>
                                <div class="van-field__button" v-else>
                                    <div size="small" type="primary" style="color: rgb(240, 169, 25); font-size: 0.28rem; height: 1.1rem; line-height: 1.1rem;">
                                        <span style="margin-right: 0.2rem; position: relative; top: -0.02rem;">|</span>{{timesCount}}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div id="cap" v-if="mode == 1 || mode == 2">
                    <iframe width="100%" scrolling="no" id="frame" name="frame" :src="capUrl" frameborder="0"></iframe>
                </div>
                <div class="btn_box" v-if="mode == 0 || mode ==3">
                    <img src="https://resource.0168.net.cn/activity-mall/h5/theme3/get_btn.png" class="btn_img" :class="{fixed: btnFixed}" @click="bindOpen">
                </div>
                
                <div class="product-info" v-if="mode == 0 || mode ==3">
                    <p>开通联合会员，领热门会员+话费</p>
                    <p>业务资费：6-15元/月(具体以实际产品资费为准)</p>
                    <p>客服电话：<a href="tel:4008008663">4008008663</a></p>
                </div>

                <div class="agree" v-if="mode == 0 || mode ==3">
                    <img src="https://resource.0168.net.cn/activity-mall/common/unchecked_yellow.png" v-if="!checked" @click="checked = !checked">
                    <img src="https://resource.0168.net.cn/activity-mall/common/checked_yellow.png" v-else @click="checked = !checked">
                    <span><span @click="checked = !checked">我已详细阅读并同意</span><a href="https://store.0168.net.cn/activity-mall/privacy/content.html">《<u>用户隐私协议</u>》</a>及相关条款</span>
                </div>

            </div>
        </div>

        <div class="flow_txtBox">
            <div class="flow-title1" @click="showActivityOrNot">活动说明
                <img v-if="!visibleNotes" src="https://resource.0168.net.cn/activity-mall/woread/theme1/arrow-down.png" alt="" />
                <img v-if="visibleNotes" src="https://resource.0168.net.cn/activity-mall/woread/theme1/arrow-up.png" alt="" />
            </div>
            <div class="notes" v-if="visibleNotes" v-cloak>
                <div class="bg">
                    <p>1、活动对象：2G/3G/4G/5G用户。</p>
                    <p>2、活动内容：活动期间凡首次在本页面成功开通业务（业务资费：6-15元/月，具体以实际产品资费为准），即可获得热门VIP会员任选一和1-25元随机话费红包（仅开通当月享有一次机会）。热门VIP会员（10选一）：百度网盘普通会员月卡、QQ音乐付费音乐包月卡、饿了么超级会员月卡、喜马拉雅VIP月卡、腾讯视频VIP月卡、优酷视频黄金会员月卡、爱奇艺黄金VIP会员月卡、芒果TV会员月卡、蜻蜓FM月卡、青桔单车月卡。</p>
                    <p>3、权益兑换： </p>
                    <p>（1）热门权益兑换方式：进入<a href="https://mf.0168.net.cn/benefit-platform">https://mf.0168.net.cn/benefit-platform</a>，登录后，选择您需要的权益进行兑换。</p>
                    <p>（2）话费权益兑换方式：进入<a href="https://mf.0168.net.cn/benefit-platform">https://mf.0168.net.cn/benefit-platform</a>，登录后，选择话费面值，点击“立即兑换”。兑换成功后7个工作日内系统自动充值到账； </p>
                    <p>温馨提示：使用相关权益时，请遵守相应平台的用户服务协议和权益使用协议，如违反相关协定规定，运营商和联合权益提供方均有权单独进行处理，包括但不限于中止或终止提供其所属平台的服务及要求侵权赔偿等。 </p>
                    <p>4、注意事项： </p>
                    <p>（1）每个手机号仅限参与一次；</p>
                    <p>（2）本活动业务为自动续费产品，用户订购期内不退订，下月将进行自动缴费续订； </p>
                    <p>（3）本业务退订后视作放弃本活动福利礼品，未充值到账或未兑换的礼品将不再发放（福利礼品包括会员、代金券、话费等）； </p>
                    <p>（4）已开通本业务的老用户不可再次参与本次推广活动。 </p>
                    <p>5、退订方式： 
                    <p>（1）联通退订方式：进入中国联通APP-服务-我已订购-增值业务-选择相关业务名称-退订，或者发送短信0000至10010，按提示内容退订； </p>
                    <p>（2）移动退订方式：发送短信0000至10086，按提示内容退订。 </p>
                    <p>6、由于产品价格可能出现临时调整，具体资费以实际扣费短信为准。</p>
                    <p>7、如有疑问可致电客服热线：<a href="tel:4008008663">4008008663</a>。</p>
                </div>
            </div>
        </div>

         <div id="privacy" class="flow_txtBox" v-if="mifaChannel.indexOf(channelid) > -1 || youzhengChannel.indexOf(channelid) > -1">
            <div class="flow-title1" @click="showPrivacyBoxOrNot">隐私协议
                <img v-if="!showPrivacy" src="https://resource.0168.net.cn/activity-mall/woread/theme1/arrow-down.png" alt="" />
                <img v-if="showPrivacy" src="https://resource.0168.net.cn/activity-mall/woread/theme1/arrow-up.png" alt="" />
            </div>
            <div class="notes" v-if="showPrivacy" v-cloak>
                <div class="bg">
                    <p>尊敬的用户：</p>
                    <p>1、尊重与保护用户个人信息是本服务的一项基本原则。</p>
                    <p>2、本业务需采集用户的个人信息包括：手机号码、IP地址。 </p>
                    <p>3、用户同意本服务基于以下事项使用用户的个人信息：</p>
                    <p>（1）读取、上传、记录用户个人信息数据并进行同步、分享和储存以实现部分服务功能；</p>
                    <p>（2）收集用户个人信息数据并统计、分析及研究，以改进本服务的质量；</p>
                    <p>（3）改进或提高用户的使用安全性和服务性； </p>
                    <p>（4）向用户发送本服务的重要通知和服务信息； </p>
                    <p>（5）适用法律法规规定的其他事项。 （可根据应用实际情况修改补充）除上述事项外，如未取得用户事先同意，本应用不会将用户个人信息使用于任何其他用途。 </p>
                    <p>4、本服务采取技术措施和其他必要措施，确保用户个人信息安全，防止在本服务中收集的用户个人信息泄露、毁损或丢失。 </p>
                    <p style="padding-bottom: 20px;">5、本服务承诺未经用户同意不向任何第三方公开、透露用户个人信息，但法律法规规定或有权机关的指示提供用户的个人信息除外。</p>
                    <div class="flow-title1" @click="iKnow" style="color:#000">我已知晓</div>     
                </div>
            </div>
        </div>
        
        <div class="copyright"  v-if="mifaChannel.indexOf(channelid) > -1" >
            <p>公司名称：广州巧思信息科技有限公司</p>
            <p>地址：广州市天河区新塘大街3号7栋310-92房</p>
            <p>联系电话：<a href="tel:4008008663">4008008663</a></p>
        </div>

        <div class="product-info" v-if="mode == 0 || mode ==3">
            <a href="https://beian.miit.gov.cn/" target="_blank">粤ICP备2021093402号-2</a>
        </div>

        <div class="ftxs_main" v-if="isGdt">
            <img src="https://resource.0168.net.cn/activity-mall/h5/common/bottom.jpg" class="benefit-bg">
        </div>

        <qs-msg-box :isloading="isLoading" :msg="msg" :flag="flag"></qs-msg-box>
        <qs-quit-box :showQuitModal="showQuitModal" :channelId="channelid" :phone="phonenum" :tuiaId="advertId" v-on:closeQuitModal="closeQuitModal"></qs-quit-box>
        <page-close-mask :showMask="pageClose"></page-close-mask>

        <iframe width="100%" scrolling="no"  :src="productUrl" style="display: none"></iframe>
    </div>
</template>

<script>
import 'common/css/reset.css';
import 'common/css/swiper.min.css'
import msgBox from "components/MessageBox.vue"
import quitBox from "components/TuiaQuitBox.vue"
import fullMask from "components/FullMask.vue"
import llgsdk from 'common/js/liuliangguo.js';
import closedChannels from 'common/data/closeChannel.json'


import $ from 'jquery'
import baseMethod from 'common/js/baseMethod.js'

export default {
    name: 'product',
    components: {
        "qs-msg-box" : msgBox,
        "qs-quit-box": quitBox,
        "page-close-mask": fullMask

    },
    created(){
        var _this = this;

        _this.channelid = baseMethod.getQueryString("channelid") ? baseMethod.getQueryString("channelid") : '18000000';
        _this.isGdt = baseMethod.isGuangdiantongChannel(_this.channelid);
        _this.unionSite = baseMethod.getUnionSite();
        _this.advertId = baseMethod.getAdvertId();

        _this.productId = baseMethod.getQueryString("product") ? baseMethod.getQueryString("product") : "XWPBM1Q74";
        _this.group = baseMethod.getQueryString("group");
        _this.topImgSrc = "https://resource.0168.net.cn/activity-mall/woread/theme1/top_all.jpg";
        _this.quitToUrl = _this.quitToUrl + "?channelid=" + _this.channelid; 

        _this.init();
        _this.getPageUrl();
        window.addEventListener('scroll', this.bindScroll);
        
        var pwd = baseMethod.getQueryString("pwd");
        if(pwd && pwd == '****aqear'){
            _this.pageClose = false;
        }

        if(closedChannels.close.indexOf(_this.channelid) > -1){
            _this.pageClose = true;
        }
        
       if(_this.channelid != '18000000' && _this.group != 'XY7HESWY1' && closedChannels.review.indexOf(_this.channelid) <= -1 && !baseMethod.isKAChannel(_this.channelid)){
            let state = {
                title: 'title',
                url: '#'
            }
            window.history.pushState(state, 'title', '#')
            let _this = this
            window.addEventListener('popstate', function(e) {
                _this.showQuitModal = true;
                return false
            }, false);
        }

        //本地缓存取和裕订单号
        if(localStorage.getItem("hy_order_expire") && localStorage.getItem("hy_order_expire") > new Date().getTime()){
            //没有过期 跳转至结果页
            var orderId = localStorage.getItem("hy_order_id");
            window.parent.location.href="https://store.0168.net.cn/activity-mall/cl/result_hy.html?orderId=" + orderId;
        }
    },
    data(){
        return {
            topImgSrc: "",
            inputBgImgSrc: "https://resource.0168.net.cn/activity-mall/h5/theme0222/input_bg.jpg",
            inputBgImgSrc1_2: "https://resource.0168.net.cn/activity-mall/h5/theme0222/input_bg1.jpg",
            productName: "",
            visibleNotes: true,
            showQuestion: false,
            showPrivacy: true,
            isDis: false,
            isLoading: false,
            msg: '加载中。。。',
            flag: false,
            phonenum: '',
            channelid: '',
            unionSite: '',
            wokey: '',
            advertId: '',
            productId: '',
            group: '',
            trace: '',
            capUrl:'',
            productUrl: '',
            btnFixed: false,
            showQuitModal: false,
            showRecomBox: false,
            recomProduct: "",
            recomUrl: "",
            quitActivityImgSrc: "https://resource.0168.net.cn/activity-mall/baoxian/banner.gif",
            quitBtnImgSrc:"https://resource.0168.net.cn/activity-mall/5Gn/image/5Gn_get_btn.png",
            quitToUrl:"https://u.mbldbg.com/2af4",
            getInfo: [
                '130 **** 9493 已领取爱奇艺会员 &nbsp;&nbsp;&nbsp;&nbsp;2分钟前',
                '155 **** 9512 已领取芒果TV会员月卡 &nbsp;&nbsp;&nbsp;&nbsp;2分钟前',
                '130 **** 2181 已领取饿了么超级会员月卡 &nbsp;&nbsp;&nbsp;&nbsp;3分钟前',
                '132 **** 3279 已领取腾讯会员 &nbsp;&nbsp;&nbsp;&nbsp;4分钟前',
                '132 **** 6917 已领取爱奇艺黄金会员 &nbsp;&nbsp;&nbsp;&nbsp;5分钟前',
                '155 **** 5511 已领取芒果TV会员月卡 &nbsp;&nbsp;&nbsp;&nbsp;5分钟前',
                '131 **** 7510 已领取爱奇艺黄金会员 &nbsp;&nbsp;&nbsp;&nbsp;6分钟前',
                '131 **** 1495 已领取百度网盘会员月卡 &nbsp;&nbsp;&nbsp;&nbsp;7分钟前',
                '130 **** 1043 已领取爱奇艺会员 &nbsp;&nbsp;&nbsp;&nbsp;9分钟前',
                '186 **** 1905 已领取哔哩哔哩会员月卡 &nbsp;&nbsp;&nbsp;&nbsp;9分钟前',
                '155 **** 2309 已领取优酷视频会员 &nbsp;&nbsp;&nbsp;&nbsp;10分钟前',
            ],
            checked: false,
            timesCount: 0,
            captcha: '',
            mode: "0",
            data: {},
            mifaChannel: ['450001', '410001', '420001'],
            youzhengChannel: ['680001','680002'],
            orderId: "",
            step: 1,
            isLock: false,
            attempCount: 0,
            pageClose: false,
            ruiquChannel: ['5010707002','5010707001','2010507002','2010507001','2010107002','2010107001','2010107004','2010107003','5010715001','5010715006','5010715004','1010715006','1010515001','5010715003','2010115001','5010715005','5010715002'],
            isGdt: false
        
        };
    },
    watch:{
        phonenum(now, old) {
            if (now.length == 11 && old.length == 10 && !baseMethod.isGuangdiantongChannel(this.channelid)) {
                var _this = this;
                _this.checked = true;
                _this.bindOpen();
            }
        }
    },
    methods:{
        bindScroll() {
            this.scrollHeight = document.documentElement.scrollTop || document.body.scrollTop
            if (this.scrollHeight > 600) {
                this.btnFixed = true
            } else {
                this.btnFixed = false
            }
        },
        togg() {
           return this.isDis === false ? 'display:none' : 'display:block'
        },
        bindOpen() {
            let _this = this;

            if(!_this.checked){
                    _this.showMsg("请勾选同意隐私协议及相关条款");
                    return;
            }

              if(_this.isLock && _this.attempCount > 2){
                    _this.showMsg("请10秒后再试！");
                    return;
                }

                _this.isLock = true;
                _this.attempCount++;

                setTimeout(function(){
                    _this.isLock = false;
                },10000)


            if(_this.timesCount != 0 ){
                 if (baseMethod.isEmpty(_this.captcha)) {
                    _this.showMsg("验证码不能为空！");
                    return;
                }
                _this.subCode();
                return;
            }

            if(_this.btnFixed){
                document.getElementById('inputPhone').focus();
                return;
            }
            
            if (!baseMethod.isMobile(_this.phonenum)) {
                _this.showMsg("请输入正确的手机号码");
                return;
            }

            let params = {
                product: _this.productId,
                channel_id: _this.channelid,
                tel: _this.phonenum,
                advert_id: _this.advertId,
                union_site: _this.unionSite,
                wokey: _this.wokey,
                request: window.location.href,
                preelection: _this.productUrl,
                device: JSON.stringify(_d),
                source_url: location.href
            }
            
            _this.isDis = true;
            $.ajax({
                url: 'https://api.0168.net.cn/qiaosi/product/v2/payment',
                type: 'get',
                dataType: 'json',
                data: params,
                success: function(res) {
                    _this.isDis = false;
                    if (res.code.startsWith("01")) {
                        _this.mode="1";
                        _this.capUrl = res.data.pay_url;
                        _this.step=0;
                        $("#cap").slideDown(500);
                    } else if (res.code.startsWith("02")) {
                        _this.mode="3";
                        _this.step=2;
                        _this.orderId = res.order_id;
                        _this.timesCount = 120;
                         const time = setInterval(() => {
                            if (_this.timesCount == 0) {
                                clearInterval(time)
                            } else {
                                _this.timesCount --;        
                            }
                        }, 1000)
                    } else if (res.code.startsWith("04")){
                        window.location.href = res.data.pay_url;
                        //保存订单号  created查询订单状态
                        localStorage.setItem('hy_order_id', res.order_id);
                        localStorage.setItem('hy_order_expire', new Date().getTime() + 3*60*1000);

                    } else if (res.code.startsWith("07")){
                        window.location.href = res.data.pay_url;
                    } else {
                        _this.isDis = false;
                        _this.showMsg(res.msg);
                        if(_this.channelid != '18000000' && _this.group != 'XY7HESWY1' && closedChannels.review.indexOf(_this.channelid) <= -1){
                            if(baseMethod.isTuiaChannel(_this.channelid)){
                               _this.showMsg("正在为您准备专属优惠...");
                                window.parent.location.href="https://engine.6wn9tvuhh6.cn/index/activity?appKey=2L46pGwwDGwUA6grDBuTSS2d6ek8&adslotId=462689&phone=" + Base64.encode(_this.phonenum);
                            } else {
                                llgsdk.llg(_this.phonenum, res.msg);
                            }
                        }
                    }
                },
                error: function(res) {
                    _this.isDis = false;
                    _this.showMsg("系统繁忙，请稍后再试！");
                }
            })
        },
        subCode(){
            let _this = this;

            if(_this.btnFixed){
                document.getElementById('inputPhone').focus();
                return;
            }
            
            if (!baseMethod.isMobile(_this.phonenum)) {
                _this.showMsg("请输入正确的手机号码");
                return;
            }
            let params = {
                "order_id": _this.orderId,
                "code": _this.captcha
            };
            _this.isDis = true;
            $.ajax({
                url: 'https://api.0168.net.cn/qiaosi/product/code',
                type: 'post',
                dataType: 'json',
                contentType: 'application/json',
                data: JSON.stringify(params),
                headers: {
                    'Content-Type': 'application/json'
                },
                 success: function(res) {
                    _this.isDis = false;
                    if (res.code.startsWith("5") || res.code.startsWith("4")) {
                        _this.showMsg(res.msg);
                    } else if(res.code.startsWith("6")){
                        _this.showMsg(res.msg);
                        window.parent.location.href = res.returl;
                    } else if (res.code == '00000'){
                        window.parent.location.href = res.returl;
                    }
                },
                error: function(res) {
                    _this.isDis = false;
                    _this.showMsg("系统繁忙，请稍后再试！");
                }
            });
        },
        agreePrivacy(){
            var _this = this;
            _this.checked = true;
            _this.showPrivacy = true;
        },
        showPrivacyBoxOrNot(){
            var _this = this;
            _this.showPrivacy= !_this.showPrivacy;
        },
        iKnow(){
            var _this = this;
            _this.checked = true;
            _this.onFoucs();
        },
        showMsg(msg){
            var _this = this;
            _this.isLoading = true;
            _this.msg = msg;

            setTimeout(function(){
                _this.isLoading = false;
            },1000)
        },
        closeQuitModal(){
            var _this = this;
            _this.showQuitModal = false;
        },
        closeRecomBox(){
            var _this = this;
            _this.showRecomBox = false;
        },
        showActivityOrNot(){
            var _this = this;
            _this.visibleNotes = !_this.visibleNotes;
        },
        onFoucs(){
            document.getElementById('inputPhone').focus();
            return;
        },
        init() {
            var _this = this;
            let params = {
                advert_id: _this.advertId
            }
            $.ajax({
                url: 'https://api.0168.net.cn/qiaosi/order/v3/init',
                type: 'get',
                data: params,
                dataType: "json",
                headers: {
                    'Content-Type': 'application/json'
                },
                success: function(res) {
                    console.log(res.data);
                }
            })
        },
        getPageUrl(){
            var _this = this;
            var param = {
                product: _this.productId,
                channelid: _this.channelid,
                advertId: _this.advertId,
                unionSite: _this.unionSite
            };

            //调试阶段
            if(_this.isDebug == 1 && baseMethod.getQueryString("ip")){
                param['ip'] = baseMethod.getQueryString("ip");
                param['isDebug'] = _this.isDebug;
            }

            if(localStorage.getItem('url') && localStorage.getItem("url_expire") > new Date().getTime()){
                _this.productUrl = localStorage.getItem('url')
            } else {
                $.ajax({
                  url: 'https://api.0168.net.cn/qiaosi/page/v1',
                  type: 'get',
                  data: param,
                  success: function(res){
                      var toUrl = res.data;
                      localStorage.setItem('url', toUrl);
                      localStorage.setItem('url_expire', new Date().getTime() + 30*24*60*60*1000);
                      _this.productUrl = res.data;
                  }
                });
            }
        }

    }
}
</script>

<style scoped>
    body {
        height: 100%;
    }

    #app {
        padding-top: 0;
        margin: 0;

        width:100%;
        overflow:hidden;
    }

    div {
        margin: 0;
        padding: 0;
    }

    img {
        display: block;
        margin: 0;
        padding: 0;
        border: 0;
    }


    .loading-wrap {
        position: fixed;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        z-index: 9999;
    }

    .opti_wrap.pd110 {
        padding-bottom: 110px;
    }

    .btn_img.fixed {
        position: fixed;
        bottom: 0;
        left: 5%;
        z-index: 9
    }

    .loading-box {
        border-radius: 3.2px;
        position: absolute;
        width: 120px;
        left: 50%;
        top: 50%;
        font-size: .560px;
        color: rgb(250, 250, 250);
        text-align: center;
        -webkit-transition: .3s color, .3s border;
        transition: .3s color, .3s border;
        transform: translate(-50%, -50%);
        -webkit-transform: translate(-50%, -50%);
        background: rgba(0, 0, 0, 0.6);
        flex-direction: column;
        justify-content: center;
        align-items: center;
    }

    .opti_wrap {
        background-color: #e33c50;
        position: relative;
        min-height: 100vh;
        padding-bottom: 10px;
    }

    .flow_top {
        width: 100%;
        margin: 0 auto;
        position: relative;
    }

    .flow_input_bg{
        margin-top: -10px;
        margin-bottom: -13px;
    }

    .flow_top .lottery_box {
        position: absolute;
        top: 10%;
        left: 5%;
        height: 100px;
        width: 90%;
        overflow: hidden;
    }

    .lottery_box .lotteryBg {
        width: 100%;
        margin: 0 auto;
    }


    .opti_wrap .main-top {
        width: 100%;
    }

    .flow_timer_title {
        width: 90%;
        margin: 15px auto 5px;
        padding: 1% 3%;
        position: absolute;
        bottom: 63%;
        left: 5%;
    }

    .flow_timer_title_content{
        margin-top: 10px;
        font-size: 20px;
        line-height: 18px;
        text-align: center;
        font-weight: 600;
        color: #fff;
    }

    .flow_timer_time {
        width: 90%;
        margin: 15px auto 5px;
        padding: 1% 3%;
        position: absolute;
        bottom: 33%;
        left: 5%;
    }

    .flow_timer_time_hour{
        display:inline-block;
        margin-left: 13.5%;
        font-size: 36px;
        line-height: 18px;
        text-align: center;
        font-weight: 600;
        width: 13.5%;
    }

    .flow_timer_time_minute{
        display:inline-block;
        margin-left: 15.5%;
        font-size: 36px;
        line-height: 18px;
        text-align: center;
        font-weight: 600;
        width: 13.5%;
    }

    .flow_timer_time_second{
        display:inline-block;
        margin-left: 16%;
        font-size: 36px;
        line-height: 18px;
        text-align: center;
        font-weight: 600;
        width: 13.5%;
    }

    .flow_top .flow_select {
        width: 90%;
        margin: 15px auto 5px;
        padding: 1% 3%;
        position: absolute;
        bottom: 15%;
        left: 5%;
    }

    .flow_top .flow_select1 {
        width: 90%;
        margin: 15px auto 5px;
        padding: 1% 3%;
        position: absolute;
        bottom: 5%;
        left: 5%;
    }

    .flow_top .flow_select3 {
        width: 90%;
        margin: 15px auto 5px;
        padding: 1% 3%;
        position: absolute;
        bottom: 0%;
        left: 5%;
    }

    .input_box .phone_txt{
        height: 40px;
        margin:0 2%;
        border-radius: 12px;
        width: 96%;
        border: #ff0000 1px solid;
        background: #fff;
    }

     .formElement1 {
        width: 100%;
        height: auto;
        position: relative;
        font-size: 0;
    }


    .hand-step1 {
        position: absolute;
        left: 10%;
        top: -17px;
        display: block;
        width: 70%;
        height: 21%;
        background: url(https://resource.0168.net.cn/activity-mall/h5/theme2/step1.gif) 0 0 / 100% 100%;
        pointer-events: none;
        z-index: 8;
    }

    .hand-step2 {
        position: absolute;
        left: 8%;
        top: 38px;
        display: block;
        width: 64%;
        height: 18%;
        background: url(https://resource.0168.net.cn/activity-mall/h5/theme2/step2.gif) 0 0 / 100% 100%;
        pointer-events: none;
        z-index: 8;
    }

    .formBox {
        width: 98%;
        height: auto;
        margin: 0 auto;
        border: none !important;
        background: #f1f1f1 !important;
        border-radius: 2.4rem;
        padding: 0;
        max-width: 640px;
        position: relative;
    }
    
    .formBox .form {
        width: 90%;
        height: 46px;
        line-height: .8rem;
        margin: .3rem auto 0 auto;
        font-size: .28rem;
        padding-top: 0;
        padding-bottom: 0;
        border: none !important;
        max-width: 640px;
        border-radius: .2rem;
    }
    
    .phone {
        background: #f1f1f1 !important;
    }
    
    .van-cell--required {
        overflow: visible;
    }
    
    .van-cell--required::before {
        position: absolute;
        left: 8px;
        top: 7px;
        color: #ee0a24;
        font-size: 14px;
        content: '*';
    }

    .van-cell {
        position: relative;
        display: flex;
        box-sizing: border-box;
        padding: 10px 16px;
        color: #323233;
    }
    
    .phone .van-cell__value {
        position: static;
    }
    
    .van-field__value {
        overflow: visible;
    }
    
    .van-cell__value--alone {
        color: #323233;
        text-align: left;
    }
    
    .van-cell__value {
        vertical-align: middle;
        word-wrap: break-word;
    }
    
    .van-cell__title,
    .van-cell__value {
        -webkit-box-flex: 1;
        flex: 1;
    }
    
    .van-field__body {
        display: flex;
        -webkit-box-align: center;
        align-items: center;
    }

     input {
        -webkit-writing-mode: horizontal-tb !important;
        text-rendering: auto;
        letter-spacing: normal;
        word-spacing: normal;
        text-transform: none;
        text-indent: 0px;
        text-shadow: none;
        text-align: start;
        appearance: auto;
        -webkit-rtl-ordering: logical;
        cursor: text;
    }
    
    .van-field__control {
        height: .9rem;
    }
    
    .van-field__control {
        display: block;
        box-sizing: border-box;
        width: 100%;
        height: 45px;
        min-width: 0;
        margin: 0;
        padding: 0;
        color: #323233;
        line-height: inherit;
        text-align: left;
        background-color: transparent;
        border: 0;
        resize: none;
    }

     .van-field__button {
        position: absolute;
        top: 0;
        right: 0;
    }
    
    .van-field__button {
        padding-left: 8px;
    }
    
    .van-field__button,
    .van-field__clear,
    .van-field__icon,
    .van-field__right-icon {
        flex-shrink: 0;
    }
    

    .product-info{
        margin-top: 10px;
        font-size: 12px;
        line-height: 18px;
        text-align: center;
        font-weight: 600;
        color: #fff;
    }

    .btn_box {
        margin: 0 auto;
    }

    .btn_box .btn_img {
        width: 90%;
        margin: 0 auto;
        /* -webkit-animation: mymove .8s infinite; */
    }

    .flow_abs_box1 {
        width: 320px;
        margin: 0 auto;
        display: flex;
    }
    
    .flow_abs_box1 .scroll_box {
        flex: 1;
        width: 300px;
        height: 25px;
        overflow: hidden;
    }
    


    .scroll_box li {
        align-items: center;
        height: 25px;
        font-size: 12px;
        color: #ff0000;
        text-align: center;
    }

    .swiper-wrapper {
        width: 320px;
        margin: 0 auto;
        display: flex;
    }

    .swiper-wrapper .scroll_box {
        flex: 1;
        width: 300px;
        height: 95px;
        overflow: hidden;
    }


    .swiper-wrapper .scroll_box li {
        align-items: center;
        height: 95px;
        font-size: 12px;
        color: #ff0000;
        text-align: center;
    }


    .ftxs_main {width:100%; margin: 10px auto; position: relative;}


    .vip_benefit_bg{
        margin-top: -40px;
        margin-bottom: -30px;
    }


    .swiper-top {
        position: absolute;
        z-index: 3;
        top: 43%;
        width: 100%;
        display: flex;
        justify-content: center;
    }

    .redpack_flow_abs_box1 {
        width: 18%;
        padding: 0;
        margin: 0 5px;
    }

    .redpack_flow_abs_box1 {
        display: flex;
        padding: 2px 5px;
    }

    .redpack_flow_abs_box1 .redpack_scroll_box {
        flex: 1;
        height: 95px;
        overflow: hidden;
    }

    .redpack_flow_abs_box1 .redpack_scroll_box li {
        height: 95px;
    }

    .redpack_scroll_box li {
        align-items: center;
        height: 18px;
        font-size: 12px;
        color: #fff;
    }

    .redpack_flow_abs_box1 img {
        width: 100%;
    }

    .benefit-bg{
        width:100%;
        margin-bottom: 30px;    
    }


    .swiper-con {
        position: absolute;
        bottom: 30%;
        left: 10%;
        width: 80%;
    }

    .woread-con{
        position: absolute;
        top: 25%;
        left: 10%;
        width: 80%;
    }

    .woread-con img{
        width: 100%;
        border-radius: 18px;
    }

    .swiper-con .cover {
        width: 100%;
        height: 100%;
    }

    .bottom_txt {position: absolute;bottom: 10%; left: 10%; width: 80%;  text-align: left; color: #000; font-size: 10px; line-height: 18px;}

    .flow_txtBox {
        width: 92%;
        margin: 30px auto 0;
    }

    .flow-title1 {
        width: 100%;
        text-align: center;
        font-size: 18px;
        color: #fff;
        margin: 20px 0 10px;
        letter-spacing: .2em;
    }

    .notes p {
        width: 90%;
        margin: 8px auto;
        color: #fff;
        line-height: 20px;
    }

    .notes h5 {
        width: 80%;
        margin: 10px auto;
        line-height: 20px;
    }

    .notes span{
        color: #FF0000;
    }

    .flow_txtBox .txtBg1 {
        width: 100%;
    }

    .flow_txtBox .notes {
        background: #ffc6b4;
        border-radius: 15px;
        box-shadow: 0px 2px 1px 6px #e33c50;
    }

    .bg {
        padding: 15px;
        background: #e33c51;
        border-radius: 15px;
    }

    .flow_txtBox .txtBg2 {
        width: 100%;
        margin-top: -3%;
    }

    .footer{
        width: 60%;
        margin:  20px 20%
    }

    /* .flow_txtBox a{
        color: #fff;
        font-size: 15px;
        line-height: 20px;
    } */

    .flow-title1 {
        display: flex;
        align-items: center;
        opacity: 1;
        margin-bottom: 10px;
        font-weight: 500;
        margin-left: 35%;
    }

    .flow-title1 .icon {
        width: 20px;
    }

    .agree {
        margin: 5px 0 2px;
        display: flex;
        align-items: center;
        justify-content: center;
    }
    
    .agree span {
        font-size: 10px;
        color: #fff;
        font-weight: 500;
    }
    
    .agree img {
        margin-right: 5px;
    }
    
    .agree span.red {
        color: #000;
        margin: 0 3px;
    }

     .right_txt{
        text-align: left;
        margin-left: 10%;
        margin-top: 40px;
    }

    #cap {
        width: 100%;
        height: 500px;
        position: relative;
        margin: 0px auto;
        background-size: 100% 100%;
    }
    
    #frame {
        border: 3px solid #fbd2c1;
        border-radius: 30px;
        width: 100%;
        height: 520px;
        transform:  translate(0%,0%);
    }

    a{
        word-wrap: break-word;
    }

    .copyright{
        margin-top: 30px;
        padding-left: 40px;
        padding-right: 40px;
        text-align: left;
        color: #fff;
        font-size: 8px;
    }
</style>


// WEBPACK FOOTER //
// Theme0222_2.vue?c8865eb0